import StaffAPI from '../../api/staff/StaffAPI';
import leaves from '../routes/route-name/staff/leaves';

export default async function (to, from, next) {
  try {
    const { data: countOfEmployees } = await StaffAPI.countOfEmployees();
    if (countOfEmployees <= 0) {
      next({ name: leaves.warningNoEmployees });
    }
  } catch (error) {
    console.error('fetching employees count error', { error });
    next({ name: leaves.warningNoEmployees });
  }

  next();
}
